import { BOOKING_TIME_ZONE } from "./bookingTimeZone";

/**
 * Applicants are expected on site ahead of their slot so intake paperwork doesn't eat the
 * appointment. Shared by every surface that tells someone when to arrive — the booking
 * confirmation and the manage page have to agree on the same minute.
 */
export const CHECK_IN_LEAD_MINUTES = 15;

/** Full day and time the applicant should arrive, in site local time. */
export function formatCheckInDateTime(startIso: string): string {
  const start = new Date(startIso);
  return new Date(start.getTime() - CHECK_IN_LEAD_MINUTES * 60_000).toLocaleString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: BOOKING_TIME_ZONE
  });
}

/** Day of the slot, in site local time, for an appointment nobody is going to check in to. */
export function formatAppointmentDate(startIso: string): string {
  return new Date(startIso).toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: BOOKING_TIME_ZONE
  });
}

/** Time of the slot itself, in site local time. The date lives on the check-in line above it. */
export function formatAppointmentTime(startIso: string): string {
  return new Date(startIso).toLocaleString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    timeZone: BOOKING_TIME_ZONE
  });
}
